export default "__VITE_ASSET__Dd8ehGxl__"